import { AppDomainConfig } from "../envConfig";

import app from "./app";
import asm from "./asm";
import bernmobil from "./bernmobil";
import ch from "./ch";
import demoapp from "./demoapp";
import forchbahn from "./forchbahn";
import geops from "./geops";
import io from "./io";
import oebb from "./OEBB";
import postauto from "./postauto";
import rbs from "./RBS";
import rhb from "./RhB";
import rheinbahn from "./rheinbahn";
import rvf from "./RVF";
import sbb from "./SBB";
import sob from "./SOB";
import stigwb from "./STIGWB";
import trenord from "./trenord";
import vbz from "./VBZ";
import winterthur from "./winterthur";

const ConfigId = {
  App: "app",
  Asm: "asm",
  Bernmobil: "bernmobil",
  Ch: "ch",
  Demoapp: "demoapp",
  Forchbahn: "forchbahn",
  Geops: "geops",
  Io: "io",
  Oebb: "OEBB",
  Postauto: "postauto",
  Rbs: "RBS",
  Rhb: "RhB",
  Rheinbahn: "rheinbahn",
  Rvf: "RVF",
  Sbb: "SBB",
  Sob: "SOB",
  Stigwb: "STIGWB",
  Trenord: "trenord",
  Vbz: "VBZ",
  Winterthur: "winterthur",
} as const;

export type ConfigId = (typeof ConfigId)[keyof typeof ConfigId];
export type ConfigKey = Lowercase<ConfigId>;

export default {
  app,
  asm,
  bernmobil,
  ch,
  demoapp,
  forchbahn,
  geops,
  io,
  oebb,
  postauto,
  rbs,
  rhb,
  rheinbahn,
  rvf,
  sbb,
  sob,
  stigwb,
  trenord,
  vbz,
  winterthur,
} as Record<ConfigKey, AppDomainConfig>;
